export class ListSuscripcionPeticion {
        public tokenSuscripcion: string;
        public codCliente: string;
}